<n-slide-window *ngIf="pageReady"
    [visible]="windowVisible"
    [width]="isSimpleMode ? '6.08rem' : '7rem'"
    (onHide)="onHide()">
    <n-header>
        <h1>{{i18n.manageServiceDNS}}</h1>
        <n-help-link key="fileDnsService"></n-help-link>
    </n-header>
    <app-file-dns-service #fds [vstoreId]="vstoreId" [inSlideWindow]="true"
        [simpleModeStyle]="simpleModeStyle"
        (operation)="operation()">
    </app-file-dns-service>
    <n-footer>
        <button pButton id="saveBtn" class="ui-btn-primary" [label]="i18n.confirmBtn" (click)="save()">
        </button>
        <button pButton id="cancelBtn" [label]="i18n.cancelBtn" (click)="fds.onCancel()">
        </button>
    </n-footer>
</n-slide-window>
